import RestService from "model/service/dataStorage/RestService";
import IRestServiceOptions from "model/interface/api/IRestServiceOptions";
import IHoliday from "../../interface/ui/IHoliday";
import IRestServiceCollectionResponse from "../../interface/api/IRestServiceCollectionResponse";
import {API_FILTER_TYPE} from "../../constants/ApiConstant";
import moment from "moment/moment";
import {DATE_FORMAT_DD_MM_YYYY} from "../../constants/DateConstant";

interface IRestHolidaysService {
    collectionList(options?: IRestServiceOptions): Promise<IRestServiceCollectionResponse<IHoliday>>,

    collectionListYear(year: number, countryCode?: string, options?: IRestServiceOptions): Promise<IRestServiceCollectionResponse<IHoliday>>,

    collectionCreate(data: any): Promise<IHoliday>,

    resourceRetrieve(id: number | string): Promise<IHoliday>,

    resourceUpdate(id: number | string, data: any): Promise<IHoliday>,

    resourceDelete(id: number | string): Promise<void>,

    collectionList(): Promise<IRestServiceCollectionResponse>,
}

const COLLECTION = 'holidays'

const HolidaysService: IRestHolidaysService = {
    collectionList: function (options?: IRestServiceOptions) {
        return RestService.collectionList<IHoliday>(COLLECTION, options as unknown as IRestServiceOptions)
    },
    collectionListYear: function (year, countryCode, options?: IRestServiceOptions) {
        return RestService.collectionList<IHoliday>(COLLECTION, {...options, filters: {yearFrom: {
                    field: 'holidayDate',
                    type: API_FILTER_TYPE.GREATER_OR_EQUAL,
                    value: moment().year(year).startOf('year').format(DATE_FORMAT_DD_MM_YYYY)
                }, yearTo: {
                    field: 'holidayDate',
                    type: API_FILTER_TYPE.LESSER_OR_EQUAL,
                    value: moment().year(year).endOf('year').format(DATE_FORMAT_DD_MM_YYYY)
                }, countryCode: countryCode ? {
                    field: 'countryCode',
                    type: API_FILTER_TYPE.EQUAL,
                    value: countryCode
                } : undefined, ...options?.filters}} as unknown as IRestServiceOptions)
    },
    collectionCreate: function (data) {
        return RestService.collectionCreate(COLLECTION, data)
    },
    resourceRetrieve: function (id) {
        return RestService.resourceRetrieve(COLLECTION, id)
    },
    resourceDelete: function (id) {
        return RestService.resourceDelete(COLLECTION, id)
    },
    resourceUpdate: function (id, data) {
        return RestService.resourceUpdate(COLLECTION, id, data)
    }
}

export default HolidaysService